<div class="modal-header">
    <button type="button" class="close" aria-hidden="true" (click) = 'close()'>x</button>
    <h3 class="modal-title">Fleet Safety Summary</h3>
</div>
<div class="modal-body">
    <!-- <pre>{{newUser | json}}</pre> -->
    <div class="row">
        <div class="col-md-11">
            <div *ngFor="let item of safetyEventFleet">
                <div class="form-group label-floating">
                    <label for="i4" class="control-label">{{item?.categoryType}}: {{item?.totalEvents}}</label>
                </div>
            </div>
        </div>
       
    </div>
</div>


